export default __webpack_public_path__ + "static/portal/img/fig-2.c0e8d66.png";